/**
 * ZK Authentication GraphQL Queries and Mutations
 */

import { gql } from '@apollo/client';

// ============================================================================
// Mutations
// ============================================================================

/**
 * Enroll a new ZK credential
 */
export const ZK_ENROLL = gql`
  mutation ZKEnroll($input: ZKEnrollInput!) {
    zkEnroll(input: $input) {
      id
      publicKey
      credentialType
      isActive
      createdAt
    }
  }
`;

/**
 * Request a challenge for authentication
 */
export const ZK_REQUEST_CHALLENGE = gql`
  mutation ZKRequestChallenge($publicKey: String) {
    zkRequestChallenge(publicKey: $publicKey) {
      challenge
      expiresAt
    }
  }
`;

/**
 * Verify authentication with signed challenge
 */
export const ZK_VERIFY_AUTH = gql`
  mutation ZKVerifyAuth($input: ZKVerifyInput!) {
    zkVerifyAuth(input: $input) {
      token
      client {
        id
        fName
        lName
        email
        phoneNumber
      }
    }
  }
`;

/**
 * Revoke a ZK credential
 */
export const ZK_REVOKE_CREDENTIAL = gql`
  mutation ZKRevokeCredential($credentialId: ID!) {
    zkRevokeCredential(credentialId: $credentialId)
  }
`;

// ============================================================================
// Queries
// ============================================================================

/**
 * Get helper data for a credential
 */
export const ZK_GET_HELPER_DATA = gql`
  query ZKGetHelperData($publicKey: String!) {
    zkGetHelperData(publicKey: $publicKey)
  }
`;

/**
 * Get server salt for deterministic key derivation
 */
export const ZK_GET_SALT = gql`
  query ZKGetSalt {
    zkGetSalt
  }
`;

/**
 * Get all credentials for the current user
 */
export const ZK_GET_CREDENTIALS = gql`
  query ZKGetCredentials {
    zkGetCredentials {
      id
      publicKey
      credentialType
      isActive
      createdAt
      lastUsedAt
    }
  }
`;

// ============================================================================
// Input Types (for TypeScript)
// ============================================================================

export interface ZKEnrollInput {
  publicKey: string;
  helperData: string;
  credentialType: 'FACE' | 'VOICE' | 'FACE_VOICE';
}

export interface ZKVerifyInput {
  challenge: string;
  signature: string;
  publicKey: string;
}
